import { Box, Container, Link, Stack, Typography, useTheme } from "@mui/material";
import { NavigationAndFooterLayout } from "../layouts";
import { NextPageWithLayout } from "@cm-websites/common";
import { NextSeo } from "next-seo";
import Image from "next/legacy/image";
import ImageLeft from "../../public/images/haendleranfragen/krimispiele-regal-handel.jpg";
import ImageRight from "../../public/images/haendleranfragen/krimidinner-im-buchhandel.jpg";
import NextLink from "next/link";
import React from "react";

export const HaendleranfragenPage: NextPageWithLayout = () => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <NextSeo
        description="Wir freuen uns über neue Geschäftspartner, die unsere Krimidinner in ihr Sortiment aufnehmen möchten. Bitte kontaktieren Sie uns."
        title="Händleranfragen | Culinario Mortale®"
      />
      <Container maxWidth="md" sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: 4 }}>
        <Typography variant="h1" sx={{ pb: 6 }}>
          Buchhandlungen und Händleranfragen
        </Typography>

        <Typography variant="body1" paragraph>
          Wir freuen uns über neue Geschäftspartner, die unsere Krimidinner in ihr Sortiment aufnehmen
          möchten. Krimidinner sind ein ideales Ergänzungsprodukt für ein krimiaffines Publikum.
        </Typography>
        <Typography variant="body1" paragraph>
          Wir arbeiten erfolgreich mit kleinen und großen Buchhandlungen, Fachgeschäften und
          Handelsketten zusammen. Dabei ist es unsere Überzeugung, dass eCommerce und stationärer
          Einzelhandel keine Gegensätze sein müssen. Im Gegenteil: Wir erhalten immer häufiger Anfragen
          von Kunden, die speziell nach der Verfügbarkeit im lokalen Einzelhandel nachfragen. Deshalb
          bieten wir auf unserer Seite Kunden die Möglichkeit, nach Geschäften in ihrer Nähe zu suchen,
          die unsere Titel in ihrem Sortiment führen.
        </Typography>
      </Container>
      <Container maxWidth="lg" sx={{ pt: 0, pb: 0 }}>
        <Stack direction={{ xs: "column", lg: "row" }} sx={{ width: "100%" }} spacing={{ xs: 1, lg: 3 }}>
          <Box>
            <Image
              alt="Krimidinner im Buchhandel"
              placeholder="blur"
              src={ImageLeft}
              style={{ borderRadius: theme.shape.borderRadius, overflow: "hidden" }}
            />
          </Box>
          <Box>
            <Image
              alt="Krimispiele als Ergänzungsprodukt für ein krimiaffines Publikum"
              placeholder="blur"
              src={ImageRight}
              style={{ borderRadius: theme.shape.borderRadius, overflow: "hidden" }}
            />
          </Box>
        </Stack>
      </Container>
      <Container maxWidth="md" sx={{ pt: { xs: 4, lg: 6 }, pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}>
        <Typography variant="body1" paragraph>
          Über unseren direkten, digitalbasierten Vertrieb können wir Ihnen günstige Konditionen sowie
          eine zügige Abwicklung anbieten. Bitte kontaktieren Sie uns unter{" "}
          <Link href="mailto:einkauf@culinario-mortale.de">einkauf@culinario-mortale.de</Link>, um
          weitere Informationen zu erhalten.
        </Typography>
        <Typography variant="body1" paragraph>
          Interessieren Sie sich für unsere Krimidinner als Werbeträger oder Geschenkidee? Dann besuchen
          Sie bitte unsere Seite für <NextLink href="/special-sales">Special Sales</NextLink>. Wenn Sie
          sich für unsere Krimispiel-Reihe Akte Mord® interessieren, besuchen Sie bitte{" "}
          <Link color="inherit" href="https://www.akte-mord.de">
            www.akte-mord.de
          </Link>
          .
        </Typography>
      </Container>
    </React.Fragment>
  );
};

HaendleranfragenPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default HaendleranfragenPage;
